import { SxProps } from '@mui/system'

export const simpleLineChartCustomTooltip: SxProps = {
  backgroundColor: 'common.white',
  padding: 2,
  border: '1px solid',
  borderColor: 'grey.200',
  borderRadius: 1,
}
